module.exports = __webpack_public_path__ + "static/media/HalTrace.bd8dbb56.png";